// import { useState } from 'react';
import io from 'socket.io-client';


/**
 * RestApi Implementation
 */
class RestApi {
    /**
     * Constructs RestApi Instance
     */
    constructor() {

    }

    async login(payload: any) {


        try {
            const response = await fetch(`${process.env.REACT_APP_SOCKET_URL}/login`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload)
            })
    
            const json = await response.json();

            console.log(json)
            if(json.error) {
                throw json.error
            }else{
                return json
            }
        
        } catch (error) {
            console.log("This is error from Rest api", error)
            throw error;
        }

    }

    async register(payload: any) {
        try {
            const response = await fetch(`${process.env.REACT_APP_SOCKET_URL}/register`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload)
            })
            console.log("response api", response)
    
            const json = await response.json()
            console.log(json)
            return json
        } catch (e) {
            console.log("This is error from Rest api", e)
            return e
        }
    }

    async forgotPassword(payload: any) {
        try {
            const response = await fetch(`${process.env.REACT_APP_SOCKET_URL}/forgot-password`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload)
            })

            const json = await response.json()
            console.log("JSON RESPONSE", json)
            if(json.errors) {
                throw json
            }else{
                return json
            }
        } catch (error) {
            console.log("This is error from Rest api", error)
            return error
        }
    }

    async verifyToken(payload: any) {
        const response = await fetch(
            `${process.env.REACT_APP_SOCKET_URL}/verify?code=${payload.verificationToken}`,
            {
              method: "GET",
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
              },
            }
          );
      
          const data = await response.json();
          console.log(data);
          return data;
    }

    async changePassword(payload: any, verificationToken: any) {
        try {
            const response = await fetch(`${process.env.REACT_APP_SOCKET_URL}/reset-password?code=${verificationToken}`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload)
            })

            const json = await response.json()
            console.log("JSON RESPONSE", json)
            if(json.errors) {
                throw json
            }else{
                return json
            }
        } catch (error) {
            console.log("This is error from Rest api", error)
            return error
        }
    }

}

export default new RestApi()